import { render, staticRenderFns } from "./BlobStorageConfigForm.vue?vue&type=template&id=1e55b70c&"
import script from "./BlobStorageConfigForm.vue?vue&type=script&lang=js&"
export * from "./BlobStorageConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports